// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ae5203ac","76":"cc084e74","223":"87e3c0da","232":"2184781e","329":"cce8a1d6","366":"8e5b759c","480":"6a598291","681":"21739145","787":"4bec83fb","938":"135a6c20","975":"94590037"}[chunkId] + ".chunk.js";
};